import { RosteringCutOffComponent } from "../directives/rostering-cut-off/rostering-cut-off.component";
import { RouteConfigurationComponent } from "./route-configuration.component";
import { RouteHolidayConfigComponent } from "./route-holiday-config/route-holiday-config.component";

export const routeConfigRouting = [
    { path: '', component:RouteConfigurationComponent,pathMatch:'full'},
    {path: 'route-cutoff',component: RosteringCutOffComponent },
    {path: 'holiday',component: RouteHolidayConfigComponent }
];